import {isEmpty} from "@helpers/helpers";
import {investmentCities} from "./helpers";


export function getCityEnName(city_id) {
    let city_name = '';

    for (let city of investmentCities) {
        if (Number(city_id) === Number(city.id)) {
            city_name = city.en_name;
        }
    }

    return city_name;
}

export function handleShowInvestmentModalTrack(modality) {
    const {city_id, event_section, event_view, event_position} = modality;
    const city_name = getCityEnName(city_id);

    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': 'invest-request-click',
            'event_section': event_section, // properties, areas, landing-investment
            'event_view': event_view, // show, list, grid
            'event_position': !isEmpty(event_position) ? event_position : '', // navbar, drawer, popup
            'city_name': city_name,
        });
    }
}

export function handleSubmitInvestmentTrack(city_id, event_section, event_view, event_position) {
    const city_name = getCityEnName(city_id);

    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': 'invest-request-submit',
            'event_section': event_section, // properties, areas, landing-investment
            'event_view': event_view, // show, list, grid
            'event_position': !isEmpty(event_position) ? event_position : '', // navbar, drawer, popup
            'city_name': city_name,
        });
    }
}